import {useCallback, useState} from "react";
import {IOrder} from "../model/types";
import {ordersAPI} from "./orders-api";

export const useOrders = ()=> {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const createOrder  = useCallback(async (order: IOrder) => {
        try {
            setLoading(true);
            setError(null);

            const response = await ordersAPI.add(order)

            if (!response.ok) {
                throw new Error("Ошибка оформления заказа");
            }
        } catch (err: any) {
            console.error('Order creation error:', err);
            setError(err?.message || "Ошибка оформления заказа");
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    return {loading, error, createOrder };
}